import { ClimateDataGranularity, ClimateVariable } from "./types";

const keys = {
  all: () => ["climate-data"] as const,
  rainfall: (params: {
    areaId: string;
    from: string;
    to: string;
    granularity: ClimateDataGranularity;
  }) =>
    [
      ...keys.all(),
      "rainfall",
      params.areaId,
      params.from,
      params.to,
      params.granularity,
    ] as const,
  atmospheric: (params: {
    type: ClimateVariable;
    areaId: string;
    from: string;
    to: string;
    granularity: ClimateDataGranularity;
  }) =>
    [
      ...keys.all(),
      "atmospheric",
      params.type,
      params.areaId,
      params.from,
      params.to,
      params.granularity,
    ] as const,
};

export default keys;
